module.exports = __webpack_public_path__ + "img/scoreCard.69dda548.png";